const getTimezoneNameOrOffset = ({
  timezone,
  language,
  formatType
}) => {
  const formatter = new Intl.DateTimeFormat(language, {
    timeZone: timezone,
    timeZoneName: formatType === "name" ? "long" : "short"
  });
  return formatter.formatToParts(/* @__PURE__ */ new Date()).find(({ type }) => type === "timeZoneName")?.value;
};
const formatTimezone = ({
  timezone,
  language
}) => {
  const timezoneName = getTimezoneNameOrOffset({
    timezone,
    language,
    formatType: "name"
    /* NAME */
  });
  const timezoneOffset = getTimezoneNameOrOffset({
    timezone,
    language,
    formatType: "offset"
    /* OFFSET */
  });
  return `${timezoneName} (${timezoneOffset})`;
};
const isSameDay = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const getDateRange = (date, range) => {
  const fromDate = new Date(date);
  fromDate.setDate(date.getDate() - range);
  const toDate = new Date(date);
  toDate.setDate(date.getDate() + range);
  return { fromDate, toDate };
};
export {
  formatTimezone,
  getDateRange,
  isSameDay
};
//# sourceMappingURL=format-timezone.js.map
